import { render, staticRenderFns } from "./onlineTest.vue?vue&type=template&id=1ec47fda&scoped=true"
import script from "./onlineTest.vue?vue&type=script&lang=js"
export * from "./onlineTest.vue?vue&type=script&lang=js"
import style0 from "./onlineTest.vue?vue&type=style&index=0&id=1ec47fda&lang=scss"
import style1 from "./onlineTest.vue?vue&type=style&index=1&id=1ec47fda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec47fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec47fda')) {
      api.createRecord('1ec47fda', component.options)
    } else {
      api.reload('1ec47fda', component.options)
    }
    module.hot.accept("./onlineTest.vue?vue&type=template&id=1ec47fda&scoped=true", function () {
      api.rerender('1ec47fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/onlineTest/onlineTest.vue"
export default component.exports